import React from 'react';
import styled from 'styled-components/macro';
import {
  Heading1, Heading3, NoStyleSpan, Paragraph, LinkStyled, Hr, LinkButton,
} from '../../components/typography';
import {
  Container,
  Row,
  Col,
  Div,
} from '../../components/grid';
import PriserTable from './PriserTable';
import { Image } from '../../components/Image';
import {
  Table,
  Tr,
  Th,
  Td,
} from '../../components/tables';
import { Price, Money } from '../../containers/commerce';
import { getItemDefaultInformation } from '../../content/commerce/items';

const HideImage = styled(({ breakWidth, ...props }) => <Image {...props} />)`
  @media only screen and (max-width: ${({ breakWidth }) => breakWidth}px) {
    & {
      display: none !important;
    }
  }
`;
const images = [
  [9630, 767],
  [3112, 575],
  [5310, 575],
  [3650, 575],
  [3430, 767],
  [2172, 767],
  [5051, 767],
  2610,
  2170,
  3110,
  [9420, 575],
  [5110, 575],
  9122,
  [2040, 575],
  5350,
  6110,
  [5132, 575],
  9222,
  1290,
  4362,
  5111,
  [6120, 575],
  4312,
  [9032, 767],
  [1250, 767],
  [5332, 767],
];

let currentKey = 0;
function getKey() {
  currentKey += 1;
  return currentKey;
}
export default () => (
  <Container white>
    <Row>
      <Col xs={12}>
        <Heading1>Priser på sodavand, kildevand, smoothie, Søbogaard & øl</Heading1>
        <Heading3>
          <NoStyleSpan underline>Gratis levering</NoStyleSpan> i hele Storkøbenhavn og omegn ved køb af min. 5 kasser.
          <br />
          Dag til dag levering. Ingen andre udgifter end priserne herunder.
        </Heading3>
        <Div textCenter>
          {images.map(
            (varenrOrArray) => {
              const varenr = Array.isArray(varenrOrArray) ? varenrOrArray[0] : varenrOrArray;
              const breakWidth = Array.isArray(varenrOrArray) ? varenrOrArray[1] : null;
              const info = getItemDefaultInformation(varenr);
              if (!info) {
                return null;
              }
              const {
                imageSingle,
                name,
              } = info;
              if (!imageSingle) {
                return null;
              }
              if (breakWidth) {
                return (
                  <HideImage name={imageSingle} title={name} key={`${varenr}_${getKey()}`} imageWidth="23px" marginRight="2px" breakWidth={breakWidth} />
                );
              }
              return <Image name={imageSingle} title={name} key={`${varenr}_${getKey()}`} imageWidth="23px" marginRight="2px" />;
            },
          )}
        </Div>
        <Paragraph>
          Alle priser er uden pant
        </Paragraph>
      </Col>
    </Row>
    <Row>
      <Col xs={12} sm={6}>
        <PriserTable name="KildevandUdenBrus" />
      </Col>
      <Col xs={12} sm={6}>
        <PriserTable name="KildevandMedBrus" />
      </Col>
    </Row>
    <Row>
      <Col xs={12} sm={6}>
        <PriserTable name="TyskKildevandUdenBrusUdenPant" />
        <PriserTable name="KildevandMedSmag" />
      </Col>
      <Col xs={12} sm={6}>
        <PriserTable name="ItalienskKildevandGlas" />
        <PriserTable name="ItalienskKildevandPlast" />
      </Col>
    </Row>
    <Row>
      <Col xs={12} sm={6}>
        <PriserTable name="SvenskVitaminWell" />
      </Col>
      <Col xs={12} sm={6}>
        <PriserTable name="KildevandPaller" isPalle />
      </Col>
    </Row>
    <Row>
      <Col xs={12} sm={6}>
        <PriserTable name="SodavandGlas" />
      </Col>
      <Col xs={12} sm={6}>
        <PriserTable name="Sodavand50ClPlast" />
        <PriserTable name="BroedreneAdelhardt" />
      </Col>
    </Row>
    <Row>
      <Col xs={12} sm={6}>
        <PriserTable name="BilligSodavand" />
      </Col>
      <Col xs={12} sm={6}>
        <PriserTable name="Sodavand150ClPlast" />
      </Col>
    </Row>
    <Row>
      <Col xs={12} sm={6}>
        <PriserTable name="UdenlandskSodavandGlas" />
        <PriserTable name="Sodavand2550ClDaaser" />
        <PriserTable name="UdenlandskSodavandDaase" />
      </Col>
      <Col xs={12} sm={6}>
        <PriserTable name="SoebogaardSafter" />
        <PriserTable name="IceTea" />
      </Col>
    </Row>
    <Row>
      <Col xs={12} sm={6}>
        <PriserTable name="Juice25Cl" />
        <PriserTable name="MySmoothie" />
        <PriserTable name="CocioChokolademaelk" />
      </Col>
      <Col xs={12} sm={6}>
        <PriserTable name="Oel33ClGlas" />
      </Col>
    </Row>
    <Row>
      <Col xs={12} sm={6}>
        <PriserTable name="OelCiderDaase" />
        <PriserTable name="AlkoholSodavand" />
        <PriserTable name="Vin" />
        <PriserTable name="SkovlystOel" />
      </Col>
      <Col xs={12} sm={6}>
        <PriserTable name="SpecialOel" />
      </Col>
    </Row>
    <Row>
      <Col xs={12} sm={6}>
        <Table striped1>
          <thead>
            <Tr>
              <Th>
                Pant emballage, pr. kasse
              </Th>
              <Th width="25px" textRight>
                Stk.
              </Th>
              <Th width="45px" textRight>
                Flaske
              </Th>
              <Th width="45px" textRight>
                Kasse
              </Th>
            </Tr>
          </thead>
          <tbody>
            <Tr>
              <Td>
                Kasser helt tomme
              </Td>
              <Td textRight>
                &nbsp;
              </Td>
              <Td textRight>
                &nbsp;
              </Td>
              <Td textRight bold>
                <Price embPrice varenr="800" noSuffix />
              </Td>
            </Tr>
            <Tr>
              <Td>
                Kasser helt tomme Søbogaard
              </Td>
              <Td textRight>
                &nbsp;
              </Td>
              <Td textRight>
                &nbsp;
              </Td>
              <Td textRight bold>
                <Price embPrice varenr="801" noSuffix />
              </Td>
            </Tr>
            <Tr>
              <Td>
                Kasser med flasker 25cl
              </Td>
              <Td textRight>
                30
              </Td>
              <Td textRight>
                1,00
              </Td>
              <Td textRight bold>
                <Price embPrice varenr="5350" noSuffix />
              </Td>
            </Tr>
            <Tr>
              <Td>
                Kasser med flasker 33cl
              </Td>
              <Td textRight>
                30
              </Td>
              <Td textRight>
                1,00
              </Td>
              <Td textRight bold>
                <Price embPrice varenr="3610" noSuffix />
              </Td>
            </Tr>
            <Tr>
              <Td>
                Kasser med flasker Ramløse 33cl
              </Td>
              <Td textRight>
                20
              </Td>
              <Td textRight>
                1,00
              </Td>
              <Td textRight bold>
                <Price embPrice varenr="4050" noSuffix />
              </Td>
            </Tr>
            <Tr>
              <Td>
                Kasser med flasker 50cl
              </Td>
              <Td textRight>
                24
              </Td>
              <Td textRight>
                1,50
              </Td>
              <Td textRight bold>
                <Price embPrice varenr="5352" noSuffix />
              </Td>
            </Tr>
            <Tr>
              <Td>
                Kasser med flasker 150cl
              </Td>
              <Td textRight>
                10
              </Td>
              <Td textRight>
                3,00
              </Td>
              <Td textRight bold>
                <Price embPrice varenr="5351" noSuffix />
              </Td>
            </Tr>
            <Tr>
              <Td>
                Kasser med flasker 33cl/25
              </Td>
              <Td textRight>
                24
              </Td>
              <Td textRight>
                1,00
              </Td>
              <Td textRight bold>
                <Price embPrice varenr="1110" noSuffix />
              </Td>
            </Tr>
            <Tr>
              <Td>
                Danske fadølsfustager
              </Td>
              <Td textRight>
                1
              </Td>
              <Td textRight>
                &nbsp;
              </Td>
              <Td textRight bold>
                <Price embPrice varenr="3615" noSuffix />
              </Td>
            </Tr>
            <Tr>
              <Td>
                Udenlandske + Skovlyst fadølsfustager
              </Td>
              <Td textRight>
                1
              </Td>
              <Td textRight>
                &nbsp;
              </Td>
              <Td textRight bold>
                <Price embPrice varenr="8415" noSuffix />
              </Td>
            </Tr>
            <Tr>
              <Td>
                Nørrebro Bryghus fustager
              </Td>
              <Td textRight>
                1
              </Td>
              <Td textRight>
                &nbsp;
              </Td>
              <Td textRight bold>
                <Price embPrice varenr="8015" noSuffix />
              </Td>
            </Tr>
            <Tr>
              <Td>
                Kulsyreflasker alle str.
              </Td>
              <Td textRight>
                1
              </Td>
              <Td textRight>
                &nbsp;
              </Td>
              <Td textRight bold>
                <Price embPrice varenr="8940" noSuffix />
              </Td>
            </Tr>
          </tbody>
        </Table>
      </Col>
      <Col xs={12} sm={6}>
        <PriserTable name="OBHDraughtMaster" />
        <Table striped1>
          <thead>
            <Tr>
              <Th>
                Fustager og tilbehør:
              </Th>
            </Tr>
          </thead>
        </Table>
        <Row>
          <Col xs={4} sm={6} textCenter>
            <Image imageWidth="200px" name="packs.fadoelsbar-skafte1.png" />
          </Col>
          <Col xs={8} sm={6} textCenter>
            <Image name="produkter-fadoel.navi-danske-fadoel.jpg" title="Danske Fadøl" />
            <br />
            <LinkButton to="/fadoel/priser" arrow>
              Se vores store udvalg her
            </LinkButton>
          </Col>
        </Row>
      </Col>
    </Row>
    <Row>
      <Col xs={12}>
        <Hr />
        <Paragraph>
          Priserne er uden pant,
          frit leveret overalt i Storkøbenhavn
          (gælder ikke fadølsanlæg).
          Betaling: For faste kunder,
          elektronisk overførsel inden 14 dage.
          Offentlige virksomheder kan faktureres elektronisk vi EAN nummer.
          Mindste leverance er 5 kasser eller 2 fustager.
          Hastelevering samme dag pålægges gebyr kr. <Price varenr="624" noSuffix />,-.
          Ret til ændringer i priser, udvalg og betingelser forbeholdes.
          Ved levering medtages rensorteret genbrugs returemballage.
          Evt. engangsemballage (dåser m.m.) skal afleveres til&nbsp;
          <LinkStyled external to="http://www.dansk-retursystem.dk/">DRS</LinkStyled>.
          Ubrugte returvarer pålægges et returgebyr på kr. <Price varenr="641" noSuffix />,- pr. Fustage og kr. <Money money={2500} noSuffix />,- pr. kasse.
        </Paragraph>
      </Col>
    </Row>
  </Container>
);
